exports = module.exports = require("../node_modules/.0.21.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal {\n  transition: all 0.3s ease;\n}\n.modal.in {\n  background-color: rgba(0,0,0,0.5);\n}\n.modal.zoom .modal-dialog {\n  -webkit-transform: scale(0.1);\n  transform: scale(0.1);\n  top: 300px;\n  opacity: 0;\n  transition: all 0.3s;\n}\n.modal.zoom.in .modal-dialog {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transform: translate3d(0, -300px, 0);\n  transform: translate3d(0, -300px, 0);\n  opacity: 1;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.21.0@css-loader!./~/.7.1.7@vue-loader/lib/style-rewriter.js?id=_v-6c35c1b0&file=Modal.vue!./~/.7.1.7@vue-loader/lib/selector.js?type=style&index=0!./src/Modal.vue
// module id = 142
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///src/Modal.vue?703d